// We are going to make lodash availalbe on the platform for making bot writing easier
import Lodash from "lodash";
import moment from "moment";

export default { Lodash, moment };

